exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-popover {\n  min-width: 127px !important;\n  padding: 12px 0;\n}\n.cascader-custom-popper,\n.cascader-custom-popper .el-cascader-menu,\n.cascader-custom-popper .el-cascader-menu__wrap {\n  height: 300px;\n}\n", ""]);

// exports
